var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('div',{staticClass:"error-page-wrapper"},[_c('div',[_vm._v("พบข้อผิดพลาดกรุณาลองใหม่อีกครั้ง")]),_c('div',{staticClass:"error-message"},[_vm._v("An error occurred. Please try again later.")])])])
}]

export { render, staticRenderFns }